import DynamicPageRenderer from "../../components/DynamicPageRenderer";

const GeographieSacree = () => {
  return <DynamicPageRenderer slug="histoire/geographie" />;
};

export default GeographieSacree;
